export default {"src":"/_next/static/media/timeline1.03138a22.svg","height":122,"width":623,"blurWidth":0,"blurHeight":0};